import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LOCAL_STORAGE } from 'ngx-webstorage-service';
import { CONFIGURATION_ENDPOINT, LOG_ENDPOINT } from '../core-api.constants';

interface Configuration {
  timezone: string;
  locale: string;
  loginUrl: string;
  clientId: string;
  logLevel: number;
  serverLogLevel: number;
  mLoginHost: string;
  disabledFeatures?: string[];
}

const CONFIGURATION_KEY = 'Configuration';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService implements Configuration {
  private readonly $apiUrl = environment.apiUrl;
  private readonly httpClient = inject(HttpClient);
  private readonly storage = inject(LOCAL_STORAGE);

  loadAppConfig() {
    return new Promise((resolve, reject) => {
      this.httpClient.get<Configuration>(`${this.apiUrl}${CONFIGURATION_ENDPOINT}`).subscribe(
        (data) => {
          this.appConfig = data;
          resolve(true);
        },
        (error) => {
          if (error.status !== 504 || !this.appConfig) {
            reject(error);
          } else {
            resolve(false);
          }
        },
      );
    });
  }

  private get appConfig(): Configuration {
    return this.storage.get(CONFIGURATION_KEY);
  }

  private set appConfig(conf: Configuration) {
    this.storage.set(CONFIGURATION_KEY, conf);
  }

  get apiUrl() {
    return this.$apiUrl;
  }

  get timezone() {
    return this.appConfig.timezone;
  }

  get locale() {
    return this.appConfig?.locale;
  }

  get logLevel() {
    return this.appConfig.logLevel;
  }

  get serverLogLevel() {
    return this.appConfig.serverLogLevel;
  }

  get serverLoggingUrl() {
    return `${this.$apiUrl}${LOG_ENDPOINT}`;
  }

  get loginUrl() {
    return this.appConfig.loginUrl;
  }

  get clientId() {
    return this.appConfig.clientId;
  }

  get mLoginHost() {
    // Support for legacy configuration key 'mloginHost'
    return this.appConfig.mLoginHost || (this.appConfig as any) ['mloginHost'];
  }

  get profileUrl() {
    return this.mLoginHost + '/ui/portal/mobilesdk/profile';
  }

  get paymentUrl() {
    return this.mLoginHost + '/ui/portal/mobilesdk/paymentmethods';
  }

  get disabledFeatures(): string[] | undefined {
    return this.appConfig.disabledFeatures;
  }
}
